import { create } from 'zustand';

// 双平台主题 token 表。默认值为 FS 站（蓝色系）；
// IPE 思政站（红色系）由 stores/init.ts 启动时整体覆盖，学生端另有 studentTheme。
// 值的语义约定：string 为颜色/渐变/文案；number（0/1/2）表示选用哪套内置素材或图标；
// boolean 控制区块显隐。
interface ThemeState {
  antdThemeColor?: string;
  bgColor: string;
  mainLayoutHeaderTextColor: string;
  mainLayoutHeaderUserSpaceIcon: number;
  mainLayoutHeaderUserSpaceBg: string;
  mainLayoutHeaderUserSpaceSpanBg: string;
  mainLayoutHeaderUserSpaceSpanColor: string;
  hasMainLayoutHeaderBg?: boolean;

  stepBlockBgColor: string;
  stepBlockTextColor: string;

  sidePanelLinkColor: string;

  fileCardBgColor: string;
  fileCardBorder: string;
  fileCardBorderActiveColor: string;
  fileCardBgPng: number;
  fileCardSmartGeneratePng: number;

  chatSendBtnBgColor: string;
  chatSendBtnBgHoverColor: string;

  chatSenderBorder: string;
  chatSenderHoverBorder: string;
  chatSenderHoverBoxShadow: string;
  chatBubbleLoadingSvg: number;
  chatSenderResetFormButtonBg: string;
  chatSenderResetFormButtonBefore: string;
  chatSenderResetFormButtonHoverBg: string;
  chatSenderResetFormButtonIcon: number;

  thinkDeeplyBtnColor: string;
  thinkDeeplyBtnBorder: string;
  thinkDeeplyBtnBgColor: string;
  thinkDeeplyActiveIcon: number;
  hasMainLayoutSiderBg?: boolean;
  mainLayoutSiderContentColor: string;
  mainLayoutSiderContentBg: string;
  mainLayoutSiderContentBorder: string;
  mainLayoutSiderContentIcon: number;
  mainLayoutSiderContentSelectedBg?: string;
  mainLayoutSiderContentSelectedColor?: string;
  mainLayoutSiderContentHoverBg?: string;
  mainLayoutSiderNewChatHoverBg?: string;
  mainLayoutSiderNewChatIcon?: number;

  mainLayoutSiderHistorySessionIcon: number;
  mainLayoutSiderHistorySessionCurrent: string;
  mainLayoutSiderHistorySessionText: string;
  mainLayoutSiderHistorySessionHoverBg?: string;

  teachingPlanFormLessonIcon: number;
  teachingPlanFormUnitIcon: number;
  agentFormHeaderCardBorderColor: string;
  agentFormHeaderCardBackgroundColor: string;
  agentFormBodySwitchColor: string;
  agentFormBodyRadioCheckboxColor: string;
  agentFormActionDownBorderColor: string;
  agentFormActionDownColor: string;
  agentFormSubmitHoverColor: string;
  agentFormCustomTextAreaHoverColor: string;

  agentFormActionDownHoverColor: string;
  teachingPlanFormActionButtonBackgroundColor: string;
  teachingPlanFormActionButtonHoverColor: string;

  commonTabGroupColor: string;
  coursewareCreateButtonBgColor: string;
  coursewareCreateButtonBgHoverColor: string;
  coursewareGotoCommunityImg: number;

  coursewareEmptyActionTextColor: string;
  coursewareEmptyCollaboratedImg: number;
  coursewareEmptyUsedImg: number;
  dropDownMeunColor: string;

  coursewarePublishButtonBgColor: string;
  coursewarePublishButtonBgHoverColor: string;

  coursewareDetailBgColor: string;
  coursewareScenesStepsBgColor?: string;

  coursewareInfoTabsActiveColor: string;
  emptyQualityImg: number;
  emptyUnitKnowledgePointImg: number;

  coursewareDetailCenterModuleIntroCardBgColor: string;

  filterBorderColor: string;
  filterHoverBorderColor: string;
  filterActiveBorderColor: string;

  resourceCreationUploadBorder: string;
  resourceCreationUploadHoverBorder: string;
  resourceCreationUploadBgColor: string;
  resourceCreationUploadHoverBgColor: string;
  resourceCreationUploadProgressStartColor: string;
  resourceCreationUploadProgressEndColor: string;
  resourceCreationBtnBgColor: string;
  resourceCreatButtonBgColor: string;
  resourceCreatButtonHoverBgColor: string;

  agentUploadEmptyBorder: string;
  agentUploadEmptyHoverBorder: string;
  agentUploadEmptyBg: string;
  agentUploadEmptyHoverBg: string;

  hasChatWelcomeTitleBg?: boolean;
  chatPaddingTop?: string;
  chatToolListConfig: number;
  chatToolListItemBg?: string;
  chatToolListItemTagBg: string;
  chatToolListItemTextColor: string;

  loginSignInBackground?: number;
  loginSignInSlogan?: boolean;
  loginSignInFormTitle?: string;
  hasLoginSignInFormLogo?: boolean;
  loginSignInSubjectSelect?: boolean;
  loginSignInCaptchaButtonColor?: string;
  loginSignInAgreement?: 'ipe';
  loginSignInAgreementCheckboxColor?: string;
  loginSignInFormBackground?: number;

  hiddenLogo?: boolean;

  settingsLeftNavPersonalIcon: number;
  settingsLeftNavSchoolIcon: number;
  settingsLeftNavAccountIcon: number;
  settingsLeftNavOrderIcon: number;
  settingsLeftNavAboutIcon: number;
  settingsAboutTextColor: string;
  settingsAboutTextHoverColor: string;
  settingsPersonalAvatarBg: string;
  settingsPersonalAvatarColor: string;
  settingsPersonalButtonBg: string;
  settingsAboutTitle?: string;
  settingsContractItemTitle?: string;
  settingsAboutAgreement?: 'ipe';

  notFoundIcon: number;

  aiPptChatHistoryFavoritesIcon: number;
  aiPptChatHeaderFavoritesIcon: number;
  aiPptChatLeftButtonIcon: number;
  aiPptChatLeftButtonBg: string;
  aiPptChatLeftButtonColor: string;
  aiPptChatLeftButtonBorder: string;
  aiPptChatSendButtonIcon: number;
  aiPptChatDeepCreationButtonColor: string;
  aiPptChatDeepCreationButtonBg: string;
  aiPptChatDeepCreationButtonHoverBg: string;
  aiPptChatDeepCreationButtonIcon: number;
  aiPptChatGenerateButtonIcon: number;
  aiPptChatGenerateButtonHoverColor: string;
  hasAiPptChatDeepCreationDialogDescribe?: boolean;

  moduleTabsBgColor: string;
  moduleTabsHoverBgColor: string;
  moduleTabsBorder?: string;
  moduleTabsActiveColor?: string;
  moduleTabsUnitGuideColor?: string;
  moduleTabsModuleIcon?: number;
  moduleTabsSelectedBorderGradient?: string;

  playerBackgroundColor?: string;
  playerIntroBoxColorBar?: number;
  playerGuideButtonIcon?: number;
  playerDigitalHumanBoxBg?: number;
  playerColourStyle?: number;
  playerEmptyImage?: number;
  unitGuideLayoutstyle?: number;

  resourceUnitGuideIcon: number;
  resourceUnitGuideBg: string;
  resourceCommunityTextColor: string;
  resourceQuickCreateImage: number;
  resourceQuickUploadImage: number;
  resourceEmptyScaffoldImage: number;
  resourceEmptyTeachingImage: number;
  resourceEmptyCoursewareImage: number;

  emptyWithCreateQuickPanBgColor: string;
  emptyWithCreateQuickPanBgHoverColor: string;
  emptyWithCreateQuickPanBtnBorderColor: string;
  emptyWithCreateQuickPanBtnTextColor: string;
  emptyWithCreateQuickPanBtnHoverColor: string;

  pptAddedButtonsBgColor: string;
  pptToolbarAddedBgColor: string;
  pptToolbarBg?: string;
  pptToolbarHoverBg?: string;
  pptToolbarSelectedBorderColor?: string;
  pptToolbarBorderGradient?: string;
  pptToolbarIllustration?: number;
  pptToolbarTextColor?: string;
  pptToolbarSubTextColor?: string;

  scaffoldingBgColors?: string;
  scenesStepTabsStyle?: number;
  sceneStepTabsIcon?: number;
  stepCardBorderColor: string;
  pptStepInfoTitleColor: string;
  pptStepInfoIndexColor: string;
  aigeneratePptImg: number;

  communityCoursewareImage: number;
  communityCoursewareBg: string;

  courseWareInfiniteCardButtonColor: string;
  courseWareInfiniteCardButtonColorHover: string;
  courseWareInfiniteCardButtonIcon: number;
  courseWareInfiniteCardUseButtonColor: string;
  courseWareInfiniteCardUseButtonColorHover: string;
  courseWareInfiniteCardUseButtonIcon: number;
  courseWareInfiniteCardUseButtonBorder: string;
  courseWareInfiniteCardUseButtonFontColor: string;

  learningSpaceDocumentBg: string;
  learningSpaceDocumentImage: number;

  agentMaterialBgImage: number;
  thoughtScrollBgColor: string;

  syncButtonText?: string;
  syncButtonConfirmTitle?: string;
  coursewareNavigationText: string;

  hasCoursewareUsedHref?: boolean;

  detailGoBackBtnText: string;

  sidePanelEmptyImage: number;

  scaffoldingHoverColor: string;

  antdPrimaryColor: string;
  antdPrimaryHoverColor: string;
  antdDefaultHoverBoderColor: string;
  antdDefaultHoverTextColor: string;
  antdDefaultHoverBgColor: string;

  detailePlayerEmptyImage: number;

  bubbleListBottomFadeMaskBg: string;

  chatSenderLoadingBg: string;
  chatSenderDisabledTextColor: string;
}

// 默认主题 = FS 站；非默认值全部走启动时 setState 覆盖
const useThemeStore = create<ThemeState>()(() => ({
  bgColor: '#ffffff',
  mainLayoutHeaderTextColor: 'rgba(37, 40, 43, 1)',
  mainLayoutHeaderUserSpaceIcon: 0,
  mainLayoutHeaderUserSpaceBg: '#f9f9f9',
  hasMainLayoutHeaderBg: undefined,

  stepBlockBgColor: 'rgba(66, 143, 255, 0.12)',
  stepBlockTextColor: 'rgba(59, 102, 255, 1)',
  sidePanelLinkColor: '#1677ff',

  fileCardBgColor:
    'linear-gradient(90deg,rgba(255, 255, 255, 1) 50%,rgba(243.8274688720703, 248.3792724609375, 255, 1) 100%)',
  fileCardBorder: '1px solid rgba(0, 0, 0, 0.08)',
  fileCardBorderActiveColor: 'rgba(66, 143, 255, 1)',
  fileCardBgPng: 0,
  fileCardSmartGeneratePng: 0,

  chatSendBtnBgColor: 'rgba(66, 143, 255, 1)',
  chatSendBtnBgHoverColor: 'rgba(65, 115, 207, 1)',

  chatSenderBorder: '1px solid #e4e4e4',
  chatSenderHoverBorder: 'rgba(66, 143, 255, 0.5)',
  chatSenderHoverBoxShadow: 'rgba(66, 143, 255, 0.16)',
  chatBubbleLoadingSvg: 0,
  chatSenderResetFormButtonBg:
    'linear-gradient(to right, #fdf8fd, #fcf5f3, #f8fbfe)',
  chatSenderResetFormButtonBefore:
    'linear-gradient(90deg, #f2e1f7, #f6dbce, #dde9f8)',
  chatSenderResetFormButtonHoverBg: `linear-gradient(90deg, #faf1fc, #fce9e0, #edf5ff),
            rgba(255, 255, 255, 1)`,
  chatSenderResetFormButtonIcon: 0,

  thinkDeeplyBtnColor: 'rgba(16, 111, 250, 1)',
  thinkDeeplyBtnBorder: '1px solid rgba(66, 143, 255, 0.08)',
  thinkDeeplyBtnBgColor: 'rgba(66, 143, 255, 0.1)',
  thinkDeeplyActiveIcon: 0,
  mainLayoutHeaderUserSpaceSpanBg: 'rgba(229, 244, 255, 1)',
  mainLayoutHeaderUserSpaceSpanColor: 'rgba(47, 137, 216, 1)',

  mainLayoutSiderContentColor: 'rgba(16, 111, 250, 1)',
  mainLayoutSiderContentBg: 'rgba(66, 143, 255, 0.12)',
  mainLayoutSiderContentBorder: 'rgba(66, 143, 255, 0.25)',
  mainLayoutSiderContentIcon: 0,

  mainLayoutSiderHistorySessionIcon: 0,
  mainLayoutSiderHistorySessionCurrent: 'rgba(205, 208, 220, 0.15)',
  mainLayoutSiderHistorySessionText: 'rgba(37, 40, 43, 0.85)',

  teachingPlanFormLessonIcon: 0,
  teachingPlanFormUnitIcon: 0,
  agentFormHeaderCardBorderColor: 'rgba(66, 143, 255, 1)',
  agentFormHeaderCardBackgroundColor: 'rgba(66, 143, 255, 0.08)',
  agentFormBodySwitchColor: 'rgba(111, 168, 252, 1), rgba(55, 114, 232, 1)',
  agentFormBodyRadioCheckboxColor: ' rgba(66, 143, 255, 0.65)',
  agentFormActionDownBorderColor: 'rgba(66, 143, 255, 1)',
  agentFormActionDownColor: 'rgba(16, 143, 250, 1)',
  agentFormSubmitHoverColor: '#4b74d2',
  agentFormActionDownHoverColor: 'rgba(227, 238, 255, 1)',
  teachingPlanFormActionButtonBackgroundColor: '#428fff',
  teachingPlanFormActionButtonHoverColor: '#68a6ff',
  agentFormCustomTextAreaHoverColor: '68a6ff',

  commonTabGroupColor: 'rgba(66, 143, 255, 1)',

  coursewareCreateButtonBgColor: '#428FFF',
  coursewareCreateButtonBgHoverColor: '#68A5FF',
  coursewareGotoCommunityImg: 0,

  coursewarePublishButtonBgColor: '#428fff',
  coursewarePublishButtonBgHoverColor: '#68a5ff',

  coursewareEmptyActionTextColor: '#4492ff',
  coursewareEmptyCollaboratedImg: 0,
  coursewareEmptyUsedImg: 0,
  dropDownMeunColor: '#428fff',

  coursewareDetailBgColor: 'rgba(66, 143, 255, 0.12)',

  coursewareDetailCenterModuleIntroCardBgColor: 'rgba(255, 255, 255, 0.6)',

  coursewareInfoTabsActiveColor: '#25282B',
  emptyQualityImg: 0,
  emptyUnitKnowledgePointImg: 0,

  filterBorderColor: 'rgba(199, 199, 199, 0.35)',
  filterHoverBorderColor: 'rgba(66, 143, 255, 0.8)',
  filterActiveBorderColor: 'rgba(66, 143, 255, 0.8)',

  resourceCreationUploadBorder: '1px dashed rgba(110, 120, 128, 0.2)',
  resourceCreationUploadHoverBorder: 'rgba(104, 165, 255, 1)',
  resourceCreationUploadBgColor: '#f6f9fc',
  resourceCreationUploadHoverBgColor: '#f5f9ff',
  resourceCreationUploadProgressStartColor: '#649AFF',
  resourceCreationUploadProgressEndColor: '#056BEC',
  resourceCreationBtnBgColor: 'rgba(66, 143, 255, 1)',
  resourceCreatButtonBgColor: '#428FFF',
  resourceCreatButtonHoverBgColor: '#4173cf',

  agentUploadEmptyBorder: '1px dashed rgba(104, 165, 255, 1)',
  agentUploadEmptyHoverBorder: '1px dashed rgba(66, 143, 255, 1)',
  agentUploadEmptyBg: '#f4f8ff',
  agentUploadEmptyHoverBg: '#f4f8ff',

  emptyWithCreateQuickPanBgColor: 'rgba(244, 248, 255, 1)',
  emptyWithCreateQuickPanBgHoverColor: 'rgba(235, 241, 251, 1)',
  emptyWithCreateQuickPanBtnBorderColor: 'rgba(66, 143, 255, 0.45)',
  emptyWithCreateQuickPanBtnTextColor: 'rgba(16, 111, 250, 1)',
  emptyWithCreateQuickPanBtnHoverColor: 'rgba(66, 143, 255, 1)',

  chatToolListConfig: 0,
  chatPaddingTop: '230px',
  chatToolListItemTagBg:
    'linear-gradient(90deg, rgba(199, 231, 255, 1),rgba(255, 243, 240, 1) 100%);',
  chatToolListItemTextColor: 'rgba(77, 75, 183, 1)',

  hasLoginSignInFormLogo: true,

  settingsLeftNavPersonalIcon: 0,
  settingsLeftNavSchoolIcon: 0,
  settingsLeftNavAccountIcon: 0,
  settingsLeftNavOrderIcon: 0,
  settingsLeftNavAboutIcon: 0,
  settingsAboutTextColor: '#1677ff',
  settingsAboutTextHoverColor: '#69b1ff',
  settingsPersonalAvatarBg: 'rgba(213, 231, 252, 1)',
  settingsPersonalAvatarColor: 'rgba(110, 147, 223, 1)',
  settingsPersonalButtonBg: '#3a6de9',

  notFoundIcon: 0,

  aiPptChatHistoryFavoritesIcon: 0,
  aiPptChatLeftButtonIcon: 0,
  aiPptChatLeftButtonBg: 'rgba(66, 143, 255, 0.12)',
  aiPptChatLeftButtonColor: 'rgba(16, 111, 250, 1)',
  aiPptChatLeftButtonBorder: 'rgba(66, 143, 255, 0.10)',
  aiPptChatHeaderFavoritesIcon: 0,
  aiPptChatSendButtonIcon: 0,
  aiPptChatDeepCreationButtonColor: 'rgba(37, 40, 43, 1)',
  aiPptChatDeepCreationButtonBg: 'rgba(255, 255, 255, 1)',
  aiPptChatDeepCreationButtonHoverBg: 'rgba(255, 255, 255, 1)',
  aiPptChatDeepCreationButtonIcon: 0,
  aiPptChatGenerateButtonIcon: 0,
  aiPptChatGenerateButtonHoverColor: 'rgba(37, 40, 43, 1)',
  hasAiPptChatDeepCreationDialogDescribe: true,

  moduleTabsBgColor: '#f2f8ff',
  moduleTabsHoverBgColor: '#E4EBF9',

  resourceUnitGuideIcon: 0,
  resourceUnitGuideBg: 'rgba(66, 143, 255, 0.08)',
  resourceCommunityTextColor: 'rgba(68, 146, 255, 1)',
  resourceQuickCreateImage: 0,
  resourceQuickUploadImage: 0,
  resourceEmptyScaffoldImage: 0,
  resourceEmptyTeachingImage: 0,

  pptAddedButtonsBgColor: 'rgba(255, 241, 241, 1)',
  pptToolbarAddedBgColor:
    'linear-gradient(90.00deg, rgba(79.24977111816406, 207.8866729736328, 182.15928649902344, 1),rgba(69.68733215332031, 200.28668212890625, 145.99258422851562, 1) 100%)',
  stepCardBorderColor: 'rgba(66, 143, 255, 1)',
  pptStepInfoTitleColor: 'rgba(66, 143, 255, 1)',
  pptStepInfoIndexColor: 'rgba(66, 143, 255, 0.6)',
  aigeneratePptImg: 0,

  resourceEmptyCoursewareImage: 0,

  communityCoursewareImage: 0,
  communityCoursewareBg: 'rgba(66, 143, 255, 0.08)',

  courseWareInfiniteCardButtonColor: '#428fff',
  courseWareInfiniteCardButtonColorHover: '#68a5ff',
  courseWareInfiniteCardButtonIcon: 0,
  courseWareInfiniteCardUseButtonColor: '#ffffff',
  courseWareInfiniteCardUseButtonColorHover: 'rgba(66, 143, 255, 0.12)',
  courseWareInfiniteCardUseButtonIcon: 0,
  courseWareInfiniteCardUseButtonBorder: '#428fff',
  courseWareInfiniteCardUseButtonFontColor: '#428fff',

  learningSpaceDocumentBg: 'rgba(66, 143, 255, 0.08);',
  learningSpaceDocumentImage: 0,

  agentMaterialBgImage: 0,

  thoughtScrollBgColor: 'rgba(59, 102, 255, 0.03)',

  syncButtonText: '数智化课件包组件',
  syncButtonConfirmTitle: '同步课件包组件',

  hasCoursewareUsedHref: undefined,
  coursewareNavigationText: '【数智化课件包】-【我的课件包】',

  detailGoBackBtnText: '返回数智化课件列表页',

  sidePanelEmptyImage: 0,

  scaffoldingHoverColor: 'rgba(66, 143, 255, 1)',

  antdPrimaryColor: 'rgba(66, 143, 255, 1)',
  antdPrimaryHoverColor:
    'linear-gradient(rgba(0, 0, 0, 0.2),rgba(0, 0, 0, 0.2)),#428fff',
  antdDefaultHoverBoderColor: 'rgba(110, 120, 128, 0.25)',
  antdDefaultHoverTextColor: 'rgba(37, 40, 43, 1)',
  antdDefaultHoverBgColor: 'rgba(110, 120, 128, 0.08)',

  detailePlayerEmptyImage: 0,

  bubbleListBottomFadeMaskBg: `linear-gradient(
                180deg,
                rgba(255, 255, 255, 0) 0%,
                rgba(255, 255, 255, 1) 100%
              )`,

  chatSenderLoadingBg: '#f5f5f5',
  chatSenderDisabledTextColor: 'rgba(37, 40, 43, 0.45)',
}));

export default useThemeStore;
